// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

/**
 * D-UI-3 §3 — the app's design tokens as VALUES, for the MUI theme. MUI derives shades (hover, light,
 * contrast text) with colour maths, which needs real colours, not `var(--…)`. The source of truth stays
 * the `:root` block in index.css; tokens.test.ts fails if the two drift.
 */
export const tokens = {
  bg: '#fafaf9',
  surface: '#ffffff',
  surfaceAlt: '#f5f5f4',
  border: '#e7e5e4',
  text: '#1c1917',
  textSoft: '#57534e',
  textMute: '#78716c',
  primary: '#0f766e',
  primaryHover: '#0d5e58',
  primarySoft: '#ccfbf1',
  accent: '#d97706',
  success: '#15803d',
  warning: '#ca8a04',
  danger: '#b91c1c',
  info: '#1d4ed8',
  radiusSm: 6,
  radiusMd: 8,
  radiusLg: 12,
  fontSans: "'Inter Variable', 'Inter', system-ui, -apple-system, sans-serif",
  htmlFontSize: 15,
} as const

/** index.css custom property → token key (what the sync test compares). */
export const CSS_VAR_OF: Record<string, keyof typeof tokens> = {
  '--color-bg': 'bg',
  '--color-surface': 'surface',
  '--color-surface-alt': 'surfaceAlt',
  '--color-border': 'border',
  '--color-text': 'text',
  '--color-text-soft': 'textSoft',
  '--color-text-mute': 'textMute',
  '--color-primary': 'primary',
  '--color-primary-hover': 'primaryHover',
  '--color-primary-soft': 'primarySoft',
  '--color-accent': 'accent',
  '--color-success': 'success',
  '--color-warning': 'warning',
  '--color-danger': 'danger',
  '--color-info': 'info',
}
